import { GripVertical, Copy, Trash2 } from 'lucide-react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { BlockPreview } from './BlockPreview'
import { getBlockConfig } from './block-catalog'
import type { PageBlock } from '../../../types'

interface BlockWrapperProps {
  block: PageBlock
  isSelected: boolean
  onSelect: () => void
  onDelete: () => void
  onDuplicate: () => void
}

export function BlockWrapper({ block, isSelected, onSelect, onDelete, onDuplicate }: BlockWrapperProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: block.id,
    data: { fromPalette: false },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const config = getBlockConfig(block.type)

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`group relative border-2 rounded-lg transition-colors animate-fade-slide-in ${ isSelected ? 'border-primary bg-primary/10 dark:bg-primary/20' : 'border-default-200 bg-content1 hover:border-default-300' }`}
      onClick={onSelect}
    >
      <div className="flex items-center gap-2 px-3 py-1.5 border-b border-default-100 bg-default-50/50 dark:bg-default-800/50 rounded-t-lg">
        <button className="cursor-grab active:cursor-grabbing text-default-400 hover:text-default-600" {...attributes} {...listeners}>
          <GripVertical className="w-4 h-4" />
        </button>
        <span className="text-xs font-medium text-default-500 uppercase">{config?.label || block.type}</span>
        <div className="ml-auto flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            className="text-default-400 hover:text-primary"
            onClick={(e) => { e.stopPropagation(); onDuplicate() }}
            title="Duplicate block"
          >
            <Copy className="w-3.5 h-3.5" />
          </button>
          <button
            className="text-default-400 hover:text-danger"
            onClick={(e) => { e.stopPropagation(); onDelete() }}
            title="Delete block"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
      <div className="p-4">
        <BlockPreview block={block} />
      </div>
    </div>
  )
}
